// extracted by mini-css-extract-plugin
module.exports = {"container":"container--2O7aO","icon":"icon--2i3Ac"};